<pr-dc-chart
  *ngIf="chart$ | async as chart"
  [label]="chart.label"
  [chart]="chart.chart"
  [legend]="chart.legend"
  [chartClasses]="chart.chartClasses"
 />
